import { render, staticRenderFns } from "./password.vue?vue&type=template&id=be3a0b20&scoped=true"
import script from "./password.vue?vue&type=script&lang=js"
export * from "./password.vue?vue&type=script&lang=js"
import style0 from "./password.vue?vue&type=style&index=0&id=be3a0b20&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3a0b20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be3a0b20')) {
      api.createRecord('be3a0b20', component.options)
    } else {
      api.reload('be3a0b20', component.options)
    }
    module.hot.accept("./password.vue?vue&type=template&id=be3a0b20&scoped=true", function () {
      api.rerender('be3a0b20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/user/password.vue"
export default component.exports